import MailGroups                                             from "../../../../domain/mail/group/MailGroups";
import { ACTION_TYPE, MailGroupsAction, SetMailGroupsAction } from "./MailGroupsAction";

const reduceMailGroups = (action: SetMailGroupsAction): MailGroups => action.mailGroups;

const mailGroupsReducer = (state: MailGroups = new MailGroups(), action: MailGroupsAction): MailGroups => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_MAIL_GROUPS:
      return reduceMailGroups(action as SetMailGroupsAction);
  }
};

export default mailGroupsReducer;
